import { useState, FC } from 'react';
import { Formik, Field } from 'formik';
import Portal from '../../Portal';
import cx from 'classnames';
import styles from './AddNew.module.scss';
import Button from '../../GroupActions/Button';
import TextField from '../../Inputs/TextField';
import SelectField from '../../Inputs/SelectField';
import ToggleField from '../../Inputs/ToggleField';
// import RadioField from '../../Inputs/RadioField;

export interface AddNewFormProps {
  onClick: (k: string) => void;
}
const AddNewForm: FC<AddNewFormProps> = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Button theme='accent' variant='rounded' onClick={() => setIsOpen(true)}>
        Add New Group
      </Button>
      {isOpen && (
        <Portal selector='#modal'>
          <div className={styles.modal}>
            <div className={styles.modal__shade} onClick={() => setIsOpen(false)} />
            <div className={styles.modal__form}>
              <Formik
                initialValues={{
                  group_name: '',
                }}
                onSubmit={(values) => {
                  onClick(values.group_name);
                  setIsOpen(false);
                }}
              >
                {({ values, handleSubmit }) => (
                  <>
                    {isOpen && (
                      <>
                        <TextField name='group_name' label='Group Name' />

                        <Button theme='primary' variant='rounded' onClick={handleSubmit} label='Submit' />
                      </>
                    )}
                  </>
                )}
              </Formik>
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default AddNewForm;
